import axios, { AxiosError } from 'axios'
import store from '@/store'
import router from '@/router'

axios.defaults.timeout = process.env.VUE_APP_API_TIMEOUT || 0

type ErrorResponseField = {
  message: string;
  property: string;
}

type ParsedErrors = {
  [key: string]: string;
}

function errorResponseToErrors (config: AxiosError): ParsedErrors {
  const errorResponse = config.response && config.response.data ? config.response.data : {}
  if (!('message' in errorResponse) || !Array.isArray(errorResponse.message)) {
    return {}
  }
  return errorResponse.message.reduce((a: ParsedErrors, msg: ErrorResponseField) => {
    // 同じpropertyが複数あれば上書きになる（基本フロントでvalidationするので、バックエンドからそのようなレスポンスまで考えていません、問題があればその時検討する）
    a[msg.property] = msg.message
    return a
  }, {})
}

const checkError = (config: AxiosError): Promise<ParsedErrors | AxiosError> => {
  store.commit('isLoadingForce', false)
  if (config.isAxiosError) {
    if (config.message.includes('timeout')) { // timeout of 10ms exceeded
      // axios で設定したタイムアウト
      router.push('/error/500')
      return Promise.reject(config)
    } else if (config.message.includes('status code 504')) { // Request failed with status code 504
      // APIの向き先と疎通が取れない
      router.push('/error/500')
      return Promise.reject(config)
    } else if (config.message === 'Network Error') { // ネットワーク切断
      router.push('/error/500')
      return Promise.reject(config)
    }
  }
  const code = config.response ? config.response.status : -1
  if (code === 400) {
    // サインアップ、ログイン時のみ、共通の400エラー画面に遷移する
    const apiBaseUsl = 'api/online/'
    const targetUrls = ['signUp', 'login', 'registerUser', 'authenticate']
    if (targetUrls.some(targetUrl => config.config.url?.endsWith(apiBaseUsl + targetUrl))) {
      router.push('/error/400')
      return Promise.reject(config)
    }
  } else if (code === 401) {
    if (!config.config.url?.endsWith('api/online/authenticate')) {
      // 認証エラー（ログイン時以外のみdispatchする）
      store.dispatch('notAuthorized')
      return Promise.reject(config)
    }
  } else if (code === 403) {
    router.push('/error/403')
    return Promise.reject(config)
  } else if (code === 404) {
    router.push('/error/404')
    return Promise.reject(config)
  } else if (code >= 500) {
    router.push('/error/500')
    return Promise.reject(config)
  }
  return Promise.reject(errorResponseToErrors(config))
}

// リクエストヘッダにJWTトークンを付与する
axios.interceptors.request.use((config) => {
  const jwt = store.getters.jwt
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`
  }
  return config
})
// ステータスコードチェック
axios.interceptors.response.use(response => response, checkError)
// ローディング表示
axios.interceptors.request.use(config => {
  if (!store.state.loading.isLoading) {
    store.commit('isLoading', true)
  }
  return config
})
axios.interceptors.response.use(config => {
  if (!store.state.loading.isLoadingForce) {
    store.commit('isLoading', false)
  }
  return config
})
